<template>
    <div class="main-content">
        <!-- 面包屑导航 -->
        <div class="d-flex flex-align-center flex-justify-between" style="width: 100%;">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/onlineTraining/course' }">课程管理</el-breadcrumb-item>
                <el-breadcrumb-item>评论管理</el-breadcrumb-item>
            </el-breadcrumb>
            <el-button size="small" class="mg-btm20 mg-rgt20" @click="$router.back()">返回</el-button>
        </div>
        <div class="main-table">
            <my-table :columns="tableForm.customColumns" :tableData="tableForm.tableData"
                :loading="tableForm.isLoading">
                <el-table-column align="center" prop="userSex" label="操作">
                    <template slot-scope="scope">
                        <el-button type="text" v-buttonAuth="'system:statistics:records'"
                            @click="getDetails(scope.row)">详情</el-button>
                        <el-popconfirm title="是否删除数据？" @confirm="handleRemove(scope.row, 1)">
                            <template #reference>
                                <el-button type="text" v-if="scope.row.ableDelete" class="col-f41">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </my-table>
        </div>
        <div class="main-pagination">
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        </div>
        <el-dialog title="详情" :visible.sync="detailsVisible" :close-on-click-modal="false" custom-class="form-dialog"
            width="40%" @close='closeDialog()'>
            <div class="board-tree">
                <div class="board-first-node">
                    <div class="board-dom">
                        <div class="board-title">{{ detailsData.commentContent }}</div>
                        <div class="board-desc">
                            <span class="board-time">{{ detailsData.createTime }}</span>
                            <div class="board-btn">
                                <el-button type="text" @click="replayAction(detailsData)">回复</el-button>
                                <el-popconfirm title="是否删除数据？" @confirm="handleRemove(detailsData, 2)">

                                    <template #reference>
                                        <el-button type="text" v-if="detailsData.ableDelete"
                                            class="col-f41">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    <div class="board-dom mg-lef20" v-for="item in  detailsData.children" :key="item.leaveWordId">
                        <div class="board-heade">
                            <span>{{ item.createdBy.userName }}</span>
                            回复
                            <span>{{ item.replyOriginUserName }}</span>：
                        </div>
                        <div class="board-title">{{ item.commentContent }}</div>
                        <div class="board-desc">
                            <span class="board-time">{{ item.createTime }}</span>
                            <div class="board-btn">
                                <el-button type="text" @click="replayAction(item)">回复</el-button>
                                <el-popconfirm title="是否删除数据？" @confirm="handleRemove(item, 2)">

                                    <template #reference>
                                        <el-button type="text" v-if="item.ableDelete" class="col-f41">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </div>
                        </div>
                    </div>
                    <div class="board-input" v-if="replyData.courseCommentId">
                        <el-input v-model="replyData.commentContent" placeholder="请输入回复内容"></el-input>&nbsp;
                        <el-button type="primary" :disabled="!replyData.commentContent"
                            @click="submitReply()">确定</el-button>
                        <el-button type="primary" @click="replyData = { commentContent: '' }">取消</el-button>
                    </div>
                </div>

            </div>
            <div slot="footer" class="dialog-footer">
                <div></div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MyTable from '@/components/myTable.vue';
import Pagination from '@/components/Pagination'
import myForm from '@/components/myForm.vue';
import courseApi from '@/api/onlineTraining/classification.js'
import { courseReviewPage, courseReviewRemove, courseReviewDetails, courseReviewAdd } from '@/api/courseReview.js'

export default {
    components: {
        MyTable,
        Pagination,
        myForm,
    },
    data () {
        return {
            courseList: [],
            tableForm: {
                customColumns: [
                    {
                        label: '评论人', prop: 'createdBy',
                        formatter: (item) => { return item.userName }

                    },
                    { label: '评论日期', prop: 'createTime' },
                ],
                tableConfig: {
                    noCheck: true,
                    isIndex: true,
                },
                tableData: [
                ],
                isLoading: false,
            },
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            detailsData: {},
            replyData: {
                commentContent: '',
            },
            detailsVisible: false,


        }
    },
    created () {
        console.log(this.$route.query)
        this.getDictionary();
        this.getData()
    },
    methods: {
        async getDictionary () {
            const courseRes = (await courseApi.courseCategoryList({ pageNum: 1, pageSize: 999999, stateSign: true })).data;
            this.courseList = courseRes;
        },
        search () {
            this.pageparm.currentPage = 1;
            this.getData();
        },
        async getData () {
            const params = {
                pageNum: this.pageparm.currentPage,
                pageSize: this.pageparm.pageSize,
                "courseId": this.$route.query.id,
            }
            const res = await courseReviewPage(params);
            this.tableForm.tableData = res.data.records;
            this.pageparm.total = res.data.total;
        },
        callFather (parm) {
            this.pageparm.currentPage = parm.currentPage
            this.pageparm.pageSize = parm.pageSize
            this.getData()
        },
        closeDialog () {
            this.detailsVisible = false;
        },
        async handleRemove (row, type = 1) {
            const res = await courseReviewRemove(row.courseCommentId);
            if (type == 1) {
                this.getData()
            } else {
                this.getDetails(this.detailsData)
            }
            this.$message({ message: '删除成功', type: 'success' });
        },
        async getDetails (row) {
            const res = await courseReviewDetails(row.courseCommentId);
            this.replyData = {
                commentContent: '',
            }
            if (!res.data) {
                this.closeDialog();
                this.getData()

                return
            }
            this.detailsData = res.data;
            this.detailsVisible = true;
        },
        replayAction (item) {
            this.replyData = JSON.parse(JSON.stringify(item));
            this.replyData['commentContent'] = '';
        },
        async submitReply () {
            const params = {
                commentContent: this.replyData.commentContent || '',
                replyOriginCommitId: this.replyData.courseCommentId || '',
                courseId: this.$route.query.id || '',
            }
            const res = await courseReviewAdd(params);
            this.getDetails(this.detailsData)
        }
    }

}
</script>

<style lang="scss" scoped>
.user-search {
    margin-top: 20px;
}

.option-from {
    font-size: 14px;
    margin-bottom: 10px;
    color: #333333;
}

.board-tree {
    margin: 40px;

    .board-first-node {
        .board-dom {
            display: flex;
            margin-top: 10px;
            flex-direction: column;

            &:not(:first-child) {
                padding-left: 30px;
            }

            .board-heade {
                display: flex;
                align-items: center;
                font-size: 25px;

                span {
                    color: #04018A;
                    padding: 0 2px;
                }
            }

            .board-title {
                margin-bottom: 5px;
                font-size: 25px;
            }

            .board-desc {
                display: flex;
                align-items: center;

                .board-time {
                    font-size: 22px;
                    margin-right: 15px;
                }
            }
        }

        .board-input {
            display: flex;
            align-items: center;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/onlineTraining/course/reviewManagement.vue